module.exports = {
      id: "angle-right-usage",
      viewBox: "0 0 192 512",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#angle-right",
      toString: function () {
        return this.url;
      }
    }